import { ApiResult, request, safeRequest } from '@synergy/api';

import { ItemPriceChangeResponse, SupplierPriceChangeResponse } from './models/shopping-cart-price-change-response';
import { ShoppingCartMinimal } from '../models/shopping-cart-minimal';

export class ShoppingCartItemApi {
    constructor(protected baseUrl: string) {}

    public addToCart = (productId: number, quantity: number): Promise<ApiResult<ShoppingCartMinimal>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/items/add`, { productId, quantity }),
            response => response.data
        );
    };

    public changeQuantity = (itemId: number, quantity: number): Promise<ApiResult<ItemPriceChangeResponse>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/items/${itemId}/quantity`, { quantity: quantity }),
            response => response.data
        );
    };

    public removeFromCart = (itemId: number): Promise<ApiResult<SupplierPriceChangeResponse>> => {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/shopping-cart/items/${itemId}`),
            response => response.data
        );
    };
}
